import React from 'react';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import { Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import antdTheme from './antdTheme';
import GlobalStyles from './assets/styles/global';
import theme from './assets/styles/theme';
import Routes from './routes';
import history from './routes/history';
import { AuthProvider } from './context/AuthContext';

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <ConfigProvider theme={antdTheme} locale={esES}>
          <Router history={history}>
            <GlobalStyles />
            <Routes />
          </Router>
        </ConfigProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}
